import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BehaviorSubject, Observable, ReplaySubject } from 'rxjs';

import { CommonApiService } from '../../proxy/services/common-api.service';
import { EntityType } from '../../proxy/models/entity-type.enum';
import { GlobalConfig } from '../../proxy/models/global-config';
import { IndexDbService } from './indexDb.service';
import { IndexDbData, IndexDbKeys } from '../../proxy/models/index-db-keys';

import { ListResult } from '../../proxy/models/common';

@Injectable({
    providedIn: 'root',
})
export class GlobalConfigsService {
    private destroyRef = inject(DestroyRef);
    private globalConfigs = new BehaviorSubject<GlobalConfig[]>([]);
    public globalConfigs$ = this.globalConfigs.asObservable();

    constructor(
        private commonApiService: CommonApiService,
        private indexDbService: IndexDbService
    ) {
    }

    public setConfigs(data: { value: GlobalConfig[], checkSumValue?: null | string }): Observable<any> {
        const result = new ReplaySubject<any>(1);
        this.indexDbService.add({
            key: IndexDbKeys.ConfigChecksum,
            value: data?.value,
            checkSumValue: data?.checkSumValue
        }).pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
            next: res => {
                this.globalConfigs.next(data.value);
                result.next(res);
            },
            error: err => result.error(err),
            complete: () => result.complete()
        });

        return result.asObservable();
    }

    public getConfigs(): Observable<IndexDbData<GlobalConfig[]>> {
        return this.indexDbService.getByKey(IndexDbKeys.ConfigChecksum);
    }

    public getConfigsSubject(): GlobalConfig[] {
        return this.globalConfigs.value;
    }

    public getAllConfigs(): Observable<ListResult<any>> {
        const data = {
            __type: 'GlobalConfiguration:#Avion.Genesis.Avalon.Core',
            EntityTypeId: EntityType.globalConfiguration,
            Description: '',
            DisplayId: 0,
            EntityId: EntityType.emptyEntityId,
            OwnerEntityId: EntityType.emptyEntityId,
            OwnerEntityTypeId: '',
        }
        return this.commonApiService.readAll(data);
    }

    public removeConfigs(): void {
        this.indexDbService.removeByKey(IndexDbKeys.ConfigChecksum);
    }
}
